module.exports = __webpack_public_path__ + "static/media/banner_JILI-full.ec32bfcb.webp";